import {
  FETCH_CONTENTS_OPTIONS,
  FETCH_CONTENTS_OPTIONS_SUCCESS,
  FETCH_CONTENTS_OPTIONS_ERROR,
} from '../actions';

const initialState = {
  isFetching: false,
  contents: {},
};

const candidates = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CONTENTS_OPTIONS:
      return {
        ...state,
        isFetching: true,
      };
    case FETCH_CONTENTS_OPTIONS_SUCCESS: {
      const { contents } = state;
      return {
        ...state,
        isFetching: false,
        contents: {
          ...contents,
          [action.occupationId]: action.data.items,
        },
      };
    }
    case FETCH_CONTENTS_OPTIONS_ERROR:
      return {
        ...state,
        isFetching: false,
      };
    default:
      return state;
  }
};

export default candidates;
